import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CheckCircle, XCircle, Loader2, ArrowLeft } from "lucide-react";
import GradientButton from "../shared/GradientButton";

export default function PaymentStatus() {
    const navigate = useNavigate();
    const { status } = useParams();
    const [counter, setCounter] = useState(10);

    useEffect(() => {
        const timer = setInterval(() => {
            setCounter((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    navigate("/");
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [navigate]);

    let icon, title, message, color;

    switch (status) {
        case "success":
            icon = <CheckCircle className="w-20 h-20 text-green-500 mb-4" />;
            title = "Payment Successful!";
            message = "Thank you for your payment. Your transaction has been completed successfully.";
            color = "text-green-500";
            break;
        case "pending":
            icon = <Loader2 className="w-20 h-20 text-yellow-500 mb-4 animate-spin" />;
            title = "Payment Processing";
            message = "Your payment is being processed. Please check again after a few moments.";
            color = "text-yellow-500";
            break;
        default:
            icon = <XCircle className="w-20 h-20 text-red-500 mb-4" />;
            title = "Payment Failed!";
            message = "Unfortunately, your payment could not be completed. Please try again.";
            color = "text-red-500";
            break;
    }

    return (
        <div className="min-h-screen flex items-center justify-center text-accent px-4 w-full">
            <div className="relative z-10 bg-darkbg/80 backdrop-blur-md border border-accentLight rounded-2xl shadow-xl p-8 w-full max-w-md text-center">
                <div className="flex flex-col items-center mb-6">
                    <img src="/logo.png" alt="MavX Logo" className="w-32 mb-8" />
                    {icon}
                    <h1 className={`text-2xl font-bold mb-2 ${color}`}>{title}</h1>
                    <p className="text-sm text-white mb-6">{message}</p>
                    <GradientButton
                        onClick={() => navigate("/")}
                        className="w-full py-3 rounded-lg font-semibold hover:bg-white transition mt-5">
                        <ArrowLeft size={22} /> Go Back ({counter}s)
                    </GradientButton>
                </div>
            </div>
        </div>
    );
}
